// @flow
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { getUserData } from '../../redux/modules/user';
import SuspendedBidderBanner from './SuspendedBidderBanner';

const mapStateToProps = (state, { isConsolePage }) => {
    const { creditCardValidated, hasEverRegisteredForAuction, standing } = getUserData(state);
    return {
        creditCardValidated,
        hasEverRegisteredForAuction,
        isConsolePage,
        standing,
    };
};

type Props = {
    creditCardValidated: boolean,
    hasEverRegisteredForAuction: boolean,
    isConsolePage: boolean,
    standing: 'n' | 's' | 'y',
};

export class SuspendedBidderBannerContainer extends PureComponent<Props> {
    render() {
        const { creditCardValidated, hasEverRegisteredForAuction, isConsolePage, standing } = this.props;
        const show = !isConsolePage && standing === 's' && (creditCardValidated || hasEverRegisteredForAuction);

        return show ? <SuspendedBidderBanner /> : null;
    }
}

export default connect(mapStateToProps)(SuspendedBidderBannerContainer);
